import React, { useEffect, useState } from "react";
import OAStepOne from "../../components/tools/oa-step-one";
import {
  getOperatingAgreementDetail,
  getOperatingAgreementList,
} from "../../stores/clients";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useDispatch } from "react-redux";
import OAStepTwo from "../../components/tools/oa-step-two";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import OAStepThree from "../../components/tools/os-step-three";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const OperatingAgreement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [oaDetail, setOaDetail] = useState<any>(null);
  const [isList, setIsList] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [pending, setPending] = useState(false);

  const comingFromButton = location.state?.fromButton;

  const loadData = async () => {
    // fetch list ALWAYS
    const listRes = await dispatch<any>(
      getOperatingAgreementList({ page: 1, limit: 10 })
    ).unwrap();

    setIsList(listRes?.data?.agreements);

    if (listRes?.data?.agreements[0]?.payment_status === "pending") {
      setPending(true);
      setLoading(false);
      return;
    }

    // if coming from button → DO NOT redirect
    if (!comingFromButton) {
      if (
        listRes?.data?.agreements?.length === 1 &&
        listRes?.data?.agreements[0]?.status !== "completed"
      ) {
        navigate("uploads");
        return;
      }
      if (listRes?.data?.agreements?.length >= 1) {
        navigate("list");
        return;
      }
    }

    // clear state if coming from button
    if (comingFromButton) {
      navigate(location.pathname, { replace: true, state: {} });
    }

    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    let interval: any;

    if (pending) {
      // start polling every 10 seconds on pending
      interval = setInterval(() => {
        loadData();
      }, 10000);
    }

    // cleanup when isPending changes or component unmounts
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [pending]);

  console.log(oaDetail);
  const detail = oaDetail?.operating_agreement_step ? oaDetail : oaDetail?.data;
  console.log(detail);
  if (loading) return <ListLoadingNew />;

  return (
    <div>
      {isList?.length > 0 && (
        <Button
          sx={{
            mb: 0.5,
            color: "#6C6F71",
            display: "flex",
            alignItems: "center",
            fontSize: "16px",
            fontWeight: 600,
            gap: 0.5,
            ml: -2,
          }}
          onClick={() => navigate("list")}
        >
          <ArrowBackIosNewIcon /> Back
        </Button>
      )}
      <OAStepOne pending={pending} />
    </div>
  );
};

export default OperatingAgreement;
